<template>
  <div id="app" class="page-brand-index">
    <div class="header">
      <div class="bg-box" :class="{ versionStyle: isStyle }" :style="{ height: bgHeight + 'px' }" />
      <div v-show="isSteep" class="pad-top" :style="{ height: statusBarHeight + 'px'}" />
      <div class="wrap" :class="{ hideTop: hideTop, versionStyle: isStyle }">
        <a href="javascript:history.back();" class="arrow" :class="{ versionStyle: isStyle, steepStyle: isSteep }"><i class="iconfont icon-arrow-left" /></a>
        <div class="title single-line-ellipsis" :class="{steepStyle: isSteep}" :style="{ 'margin-bottom': marBottom }">{{ bzBrand.brandName }}</div>
        <a class="share-icon" :class="{steepStyle: isSteep}"><i class="iconfont icon-share" /></a>
      </div>
      <div class="content">
        <div class="logo-box">
          <img :src="bzBrand.brandLogo" alt="" class="logo">
        </div>
        <div class="right-info" :class="{ versionStyle: isStyle }">
          <div class="info-content">
            <div class="num">
              <div>No.{{ rank.rank }}</div>
              <div class="info">{{ categoryName }}榜</div>
            </div>
            <div class="num">
              <div>{{ shopCount | shopCountValue }}</div>
              <div class="info">门店数</div>
            </div>
            <div class="num">
              <div>{{ postCount | postCountValue }}</div>
              <div class="info">文章</div>
            </div>
            <div class="num">
              <div>{{ attentionCount | attentionCountValue }}</div>
              <div class="info">关注</div>
            </div>
          </div>
          <div class="btn" :class="{ versionStyle: isStyle }">
            <div @click="_toAttention()">
              <a v-show="!attention" class="attention com" :class="{ versionStyle: isStyle }" :tjjj="tjjjPrefix + 'follow'">关注</a>
              <a v-show="attention" class="no-attention com" :tjjj="tjjjPrefix + 'nofollow'">已关注</a>
            </div>
            <a class="reservation-brand com" :class="{ versionStyle: isStyle }" :tjjj="tjjjPrefix + 'yybtn'" @click="reservationPopupShow">预约品牌</a>
          </div>
        </div>
      </div>
      <div class="classify-wrap">
        <div class="classify-list">
          <div v-for="item in classify" :key="item.iconClass" class="classify-item">
            <a :href="item.link" :tjjj="item.tjjj" :title="item.text">
              <i class="icon-img" :class="item.iconClass" />
              <p class="classify-name">{{ item.text }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
    <InformationFlowList :flow-list="list" :brand-id="bzBrand.brandId" :total-count="postCount" :update-time="firstRequestTime" :brand-pinyin="bzBrand.brandPinyin" :axios-url="url" :tjjj-prefix="tjjjPrefix" />
    <van-popup v-model="reservationShow" class="reservation-popup" get-container="body">
      <div class="reservation-content">
        <div class="title">预约{{ bzBrand.brandName }}品牌商</div>
        <a class="close iconfont icon-close1" @click="reservationPopupHide" />
        <Reservation :brand-id="bzBrand.brandId" :is-steep="isSteep" :status-bar-height="yystatusBarHeight" :title-height="titleHeight" :tjjj-prefix="tjjjPrefix" @reserve-success="reservationPopupHide" />
      </div>
    </van-popup>
    <van-popup v-model="popupAttention" :overlay="false" class="popup-attention">
      <div class="iconfont icon-succeed" />
      <div class="info">{{ action }}成功！</div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { compactNumberNoK } from '@ued/text-tools';
import axios from 'axios';
import { Popup, TreeSelect, Toast } from 'vant';
import Reservation from '../../components/Reservation.vue';
import InformationFlowList from '../../components/InformationFlowList.vue';
import { isApp, satisfyAppVersion, isAndroid, isIOS } from '@/lib/compatibility';
import Util from '@/lib/util';

Vue.use(Popup).use(TreeSelect).use(Toast);

const titleHeight = 82;
const noTitleBgHeight = 414;
const IosBottom = 10;
const AndroidBottom = 12;

export default {
  name: 'App',
  filters: {
    shopCountValue(value) {
      if (value >= 0) return compactNumberNoK(parseInt(value, 10));
      return null;
    },
    postCountValue(value) {
      if (value >= 0) return compactNumberNoK(parseInt(value, 10));
      return null;
    },
    attentionCountValue(value) {
      if (value >= 0) return compactNumberNoK(parseInt(value, 10));
      return null;
    },
  },
  components: {
    Reservation,
    InformationFlowList,
  },
  data() {
    return {
      classify: [{
        iconClass: 'ppgs',
        text: '品牌故事',
        link: `${globalRootUrl}ppzq/brand-${globalData.bzBrand.brandId}/ppgs/`,
        tjjj: `click_m_brands_index_${globalData.bzBrand.brandPinyin}_icon_story`,
      },
      {
        iconClass: 'zsjt',
        text: '知识讲堂',
        link: `${globalRootUrl}ppzq/brand-${globalData.bzBrand.brandId}/zhishi/`,
        tjjj: `click_m_brands_index_${globalData.bzBrand.brandPinyin}_icon_hall`,
      },
      {
        iconClass: 'rmbk',
        text: '热门爆款',
        link: `${globalRootUrl}ppzq/brand-${globalData.bzBrand.brandId}/bktj/`,
        tjjj: `click_m_brands_index_${globalData.bzBrand.brandPinyin}_icon_goods`,
      },
      {
        iconClass: 'hdwd',
        text: '互动社区',
        link: `//m.jia.com/luntan/list/${globalData.bzBrand.forumId}/`,
        tjjj: `click_m_brands_index_${globalData.bzBrand.brandPinyin}_icon_ask`,
      },
      {
        iconClass: 'wpmd',
        text: '旺铺门店',
        link: `${globalRootUrl}ppzq/brand-${globalData.bzBrand.brandId}/dianpu/`,
        tjjj: `click_m_brands_index_${globalData.bzBrand.brandPinyin}_icon_shops`,
      }],
      bzBrand: {},
      rank: {},
      attention: globalData.attention,
      action: '',
      postCount: 0,
      shopCount: 0,
      attentionCount: 0,
      firstRequestTime: globalData.frt,
      categoryName: '',
      popupAttention: false,
      reservationShow: false,
      list: [],
      hideTop: false,
      url: `${globalRootUrl}ppzq/index/${globalData.bzBrand.brandId}`,
      isStyle: false,
      isSteep: false,
      navBarHeight: 124,
      yystatusBarHeight: 0,
      titleHeight: 0,
    };
  },
  computed: {
    tjjjPrefix() {
      return `click_m_brands_index_${this.bzBrand.brandPinyin}_`;
    },
    statusBarHeight() {
      return this.hideTop || !this.isSteep ? 0 : this.navBarHeight - Util.px2docpx(titleHeight);
    },
    bgHeight() {
      return Util.px2docpx(noTitleBgHeight) + (this.hideTop ? 0 : (this.isSteep ? this.navBarHeight : Util.px2docpx(titleHeight)));
    },
    marBottom() {
      return this.isSteep ? (isAndroid || !isIOS ? `${Util.px2docpx(AndroidBottom)}px` : `${Util.px2docpx(IosBottom)}px`) : 0;
    },
  },
  created() {
    const params = Util.parseSearchParams(window.location.search);
    this.isSteep = isApp && params.is_steep === 'true';
    this.isStyle = isApp && (!satisfyAppVersion('3.2.6') || params.is_dark !== 'true');
    if (this.isSteep && params.navBarHeight) {
      this.navBarHeight = Number.parseFloat(params.navBarHeight, 10);
      this.titleHeight = Util.px2docpx(titleHeight);
      this.yystatusBarHeight = this.navBarHeight - this.titleHeight;
    } else this.navBarHeight = Util.px2docpx(this.navBarHeight);
  },
  mounted() {
    this.$nextTick(() => {
      this._initData();
    });
    if (isApp || window.location.host === 'h5.m.jia.com' || navigator.userAgent.match(/QIJIA/i) || navigator.userAgent.match(/MicroMessenger/i) || window.location.host === 'zixun.m.jia.com' || typeof (Device) !== 'undefined' || window.location.host === 'zm.jia.com' || window.location.host === 'baidu.m.jia.com') {
      this.hideTop = !this.isSteep;
    }
  },
  methods: {
    composetjjj(middle, index) {
      return `${this.tjjjPrefix}${middle}_${index}`;
    },
    _initData() {
      globalData.linkedShop = globalData.bzBrand.linkedShop;
      Object.assign(this.$data, globalData);
      this.globalRootUrl = globalRootUrl;
      this.bzBrand = globalData.bzBrand;
      this.rank = globalData.rank;
      this.list = globalData.flow;
    },

    _toAttention() {
      const action = this.attention ? '取消' : '关注';
      let url = `${globalRootUrl}brand/attention`;
      if (this.attention) {
        url += '/cancel';
      }
      axios({
        method: 'post',
        url: `${url}/${this.bzBrand.brandId}`,
        withCredentials: true,
      })
        .then((res) => {
          const { data } = res;
          if (!data) throw new Error(`${action}失败`);
          if (data !== null && data.errno < 0) { window.location.href = data.url; return; }
          const { code } = data;
          if (code === 1) {
            // Toast.success(`${action}成功`);
            this.popupAttention = true;
            this.action = action;
            setTimeout(() => {
              this.popupAttention = false;
            }, 3000);
            if (this.attention) {
              if (this.attentionCount > 0) this.attentionCount--;
            } else {
              this.attentionCount++;
            }
            this.attention = !this.attention;
          } else {
            Toast.fail(`${action}失败`);
          }
        }).catch((err) => {
          console.warn(err);
          Toast('网络出了点小问题，请稍后再试');
        });
    },

    reservationPopupShow() {
      this.reservationShow = true;
    },
    reservationPopupHide() {
      this.reservationShow = false;
    },
  },
};
</script>

<style lang="less">
@import "../../style/common.less";
@import "../../style/swiper.min.css";

.page-brand-index {
  .header {
    position: relative;
    max-width: 100%;
    // overflow: hidden;

    .bg-box {
      position: absolute;
      left: 0;
      top: 0;
      width: 750px;
      // height: 494px;
      z-index: -1;
      background: linear-gradient(135deg, rgba(65, 62, 92, 1), rgba(38, 36, 64, 1));

      &.versionStyle {
        background: #fc0;
      }

      // &.isHeight {
      //   height: 434px;
      // }

      // &.isSteep {
      //   height: 534px;
      // }
    }

    .pad-top {
      width: 750px;
      height: 40px;
      background-color: transparent;
    }

    .wrap {
      display: flex;
      flex-wrap: nowrap;
      padding: 20px 28px 0;
      color: @white;
      font-size: 34px;
      align-items: center;
      justify-content: space-between;

      .title {
        width: 310px;
        text-align: center;
      }

      &.versionStyle {
        color: @black;
      }

      a {
        color: @white;

        .versionStyle {
          color: @black;
        }

        &.steepStyle {
          display: none;
        }
      }

      .icon-arrow-left {
        margin-left: -10px;
        display: block;
        font-size: 56px;
      }

      .icon-share {
        font-size: 48px;
      }

      .share-icon {
        background: none;
        width: auto;
        height: auto;
      }

      &.hideTop {
        // transform: translateY(-100px);
        display: none;
      }

      .title.steepStyle {
        // margin: 0 auto;
        // line-height: 64px;
        margin-top: -6px;
        margin-left: auto;
        margin-right: auto;
      }
    }

    .content {
      padding: 42px 28px 42px;
      display: flex;

      .logo-box {
        width: 182px;
        height: 182px;
        border-radius: 10px;
        background: @white;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 50px;

        .logo {
          width: 182px;
          height: 109px;
          object-fit: contain;
        }
      }

      .right-info {
        flex: 1;
        color: @white;

        &.versionStyle {
          color: @black;
        }

        .info-content {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          justify-content: space-between;
          align-items: center;

          .num {
            font-size: 36px;
            font-weight: bold;
            text-align: center;

            .info {
              font-size: 22px;
              font-weight: 400;
            }

            &:last-child {
              padding-right: 21px;
            }
          }
        }

        .btn {
          a {
            display: block;
          }

          margin-top: 46px;
          display: flex;
          flex-wrap: nowrap;
          justify-content: space-between;
          color: @white;
          .font-small();

          &.versionStyle {
            color: @black;
          }

          .com {
            width: 214px;
            height: 56px;
            line-height: 56px;
            border-radius: 28px;
            text-align: center;

            &.attention {
              border: 1PX solid @white;

              &.versionStyle {
                border: 1PX solid @black;
              }
            }

            &.no-attention {
              border: 1PX solid #787597;
              color: #777597;
            }

            &.reservation-brand {
              background: linear-gradient(90deg, rgba(255, 94, 50, 1), rgba(254, 43, 43, 1));

              &.versionStyle {
                background: #362c2b;
                color: @white;
              }
            }
          }
        }
      }
    }

    .classify-wrap {
      margin: 0 28px 0;
      background: @white;
      border: 1PX solid #eaeaea;
      box-shadow: 0 20px 35px 0 rgba(166, 166, 166, 0.15);
      border-radius: 10px;

      .classify-list {
        display: flex;
        align-items: center;
      }

      .classify-item {
        flex: 1;
        text-align: center;
        font-size: 24px;
        color: @black;
        margin: 45px 0 50px;

        & > a {
          display: block;
          color: @black;
          text-decoration: none;
        }
      }

      .icon-img {
        display: inline-block;
        width: 104px;
        height: 82px;

        &.ppgs {
          background: url("../../images/icon-ppgs.png") no-repeat;
          background-size: 102px auto;
          background-position: center center;
        }

        &.zsjt {
          background: url("../../images/icon-zsjt.png") no-repeat;
          background-size: 102px auto;
          background-position: center center;
        }

        &.rmbk {
          background: url("../../images/icon-rmbk.png") no-repeat;
          background-size: 103px auto;
          background-position: center center;
        }

        &.hdwd {
          background: url("../../images/icon-hdwd.png") no-repeat;
          background-size: 102px auto;
          background-position: center center;
        }

        &.wpmd {
          background: url("../../images/icon-wpmd.png") no-repeat;
          background-size: 101px auto;
          background-position: center center;
        }
      }

      .classify-name {
        line-height: 1.8;
        color: @black;
        text-align: center;
        margin: 0;
        .font-small();
      }
    }
  }

  .com-section.mar {
    margin: 10px 28px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);

    .com-section-title {
      padding-bottom: 0;
      .font-page-title();
    }
  }

  .popup-attention {
    width: 194px;
    height: 194px;
    border-radius: 20px;
    background-color: rgba(0, 0, 0, 0.75);
    text-align: center;
    color: @white;

    .iconfont {
      font-size: 60px;
      margin: 40px 0 18px;
    }

    .info {
      color: @white;
      margin: 0;
      padding: 0;
      .font-normal();
    }
  }
}

.reservation-popup {
  padding: 70px 40px 0 40px;
  border-radius: 12px;
  background: @white;
  width: 600px;
  box-sizing: border-box;

  .reservation-content {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .title {
    font-size: 36px;
    font-weight: bold;
    color: @black;
    margin: 0 0 40px;
    line-height: 1;
    text-align: center;
  }

  .close {
    position: absolute;
    right: -12px;
    top: -50px;
    font-size: 42px;
    color: @black;
    cursor: pointer;
    font-weight: bold;
  }
}

  </style>
